import React, { PureComponent } from 'react';

class TablaFiltrosRow extends PureComponent {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        $('[data-toggle="tooltip"]').tooltip();
    }
    componentDidUpdate() {
        $('[data-toggle="tooltip"]').tooltip();
    }

    render() {
        const { ajusteCargo, idChecksAjusteCargoArray, destildarTildarCheckFiltroAjusteCargo } = this.props;

        let checkConfirmar = false;
        let textoTooltip = "", codigoDescripcion = "";

        if (idChecksAjusteCargoArray && idChecksAjusteCargoArray.length > 0) {
            checkConfirmar = idChecksAjusteCargoArray.find(checkId => checkId == ajusteCargo.ID);

            checkConfirmar = checkConfirmar ? true : false;;
        }

        if (ajusteCargo.CodigoDescripcion && ajusteCargo.CodigoDescripcion.length > 36) {
            textoTooltip = ajusteCargo.CodigoDescripcion;
            codigoDescripcion = ajusteCargo.CodigoDescripcion.substr(0, 36);
            codigoDescripcion = codigoDescripcion + "...";
        } else {
            codigoDescripcion = ajusteCargo.CodigoDescripcion;
        }

        return (
            <tr>
                <td>
                    <div data-toggle="tooltip" key={ajusteCargo.ID} data-title={textoTooltip} data-placement="right" >
                        <input type="checkbox" id={ajusteCargo.ID} checked={checkConfirmar} onClick={() => destildarTildarCheckFiltroAjusteCargo(ajusteCargo.ID, checkConfirmar)} />
                        <label className="label-secondary modal-filtros-lbl-descripcion">{codigoDescripcion}</label>
                    </div>
                </td>
            </tr>
        );
    }
}

export default TablaFiltrosRow;